export enum NativeLangEnum {
  Unknown = '1',
  Yes = '2',
  No = '3',
}

export const NativeLangOptions = [
  { id: NativeLangEnum.Unknown, name: 'Unknown' },
  { id: NativeLangEnum.Yes, name: 'Yes' },
  { id: NativeLangEnum.No, name: 'No' },
];
